import styled from "styled-components";
import { Link } from "react-router-dom";

export const Wrap = styled.div`
  position: relative;
`;

export const Cover = styled.div`
  height: 132px;
  position: relative;
  background: ${(p) => p.theme.tokens.colors.tealDeep};

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(11, 92, 78, 0) 40%, rgba(11, 92, 78, 0.35));
  }
`;

export const Card = styled.div`
  margin: -46px 14px 0;
  position: relative;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.xl}px;
  padding: 16px 16px 14px;
  box-shadow: 0 10px 30px rgba(16, 32, 27, 0.1);
  border: 1px solid ${(p) => p.theme.tokens.colors.softBg};
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const TopRow = styled.div`
  display: flex;
  gap: 13px;
  align-items: flex-start;
`;

export const Avatar = styled.div`
  width: 58px;
  height: 58px;
  margin-top: -36px;
  border-radius: 17px;
  flex-shrink: 0;
  overflow: hidden;
  background: ${(p) => p.theme.tokens.colors.surface};
  box-shadow: 0 6px 16px rgba(16, 32, 27, 0.14);
  border: 3px solid ${(p) => p.theme.tokens.colors.surface};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const NameBlock = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Name = styled.div`
  font-weight: 900;
  font-size: 19px;
  color: ${(p) => p.theme.tokens.colors.ink};
  letter-spacing: -0.4px;
  line-height: 1.1;
`;

export const Tagline = styled.div`
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 3px;
`;

export const StatusPill = styled.span<{ $open: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${(p) => (p.$open ? "#E7F8EF" : p.theme.tokens.colors.softBg)};
  color: ${(p) => (p.$open ? "#11935F" : p.theme.tokens.colors.muted)};
  font-weight: 800;
  font-size: 12.5px;
  padding: 7px 12px;
  border-radius: 999px;
  white-space: nowrap;
`;

export const StatusDot = styled.span<{ $open: boolean }>`
  width: 7px;
  height: 7px;
  border-radius: 4px;
  background: ${(p) => (p.$open ? p.theme.tokens.colors.green : p.theme.tokens.colors.muted)};
  box-shadow: ${(p) => (p.$open ? "0 0 0 3px rgba(31,184,119,0.2)" : "none")};
`;

export const InfoLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 8px;
  line-height: 1.4;
`;

export const MetaRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 13px;
`;

export const MetaCard = styled.div<{ $clickable?: boolean }>`
  flex: 1;
  background: #f6f8f7;
  border-radius: 13px;
  padding: 9px 10px;
  cursor: ${(p) => (p.$clickable ? "pointer" : "default")};
  border: none;
  text-align: left;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const MetaLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

export const MetaValue = styled.div`
  font-weight: 800;
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.ink};
  margin-top: 3px;
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 9px;
  margin-top: 14px;
`;

export const OrdersLink = styled(Link)`
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-decoration: none;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: 12.5px;
  padding: 7px 12px;
  border-radius: 999px;
  background: ${(p) => p.theme.tokens.colors.surface};
  color: ${(p) => p.theme.tokens.colors.teal};
  border: 1.4px solid #dceae5;
`;
